export default __webpack_public_path__ + "static/media/logo.62a08da3.jpg";